<div class="min-h-[16px] text-gray-500 dark:text-gray-400"><slot /></div>
